import { useMediaQuery } from "@mui/material";

interface IUseScreenResolutionResult {
  isMobile: boolean;
  isDesktop: boolean;
}

export const MOBILE_MAX_WIDTH = 576;

export const useScreenResolution = (): IUseScreenResolutionResult => {
  const isMobile = useMediaQuery(`(max-width:${MOBILE_MAX_WIDTH}px)`);

  return {
    isMobile,
    isDesktop: !isMobile,
  };
};
